<script>
    import {onMount} from "svelte";
    import CommentFormComponent from "./CommentFormComponent.svelte";
    import { tick } from 'svelte';
    import CommentContent from "./CommentContent.svelte";

    export let config;
    export let cid;

    let comments = undefined;

    let answerToComment = {
        id: null,
        preview: ""
    }

    onMount(() => {
        loadComments();
    })

    const fetchComments = () => {
        return fetch(config.model_root + 'shared/contents/comments/load_comments.php?cid=' + cid, {
            method: "GET"
        })
            .then(response => response.json())
    }

    const loadComments = () => {
        comments = undefined;
        fetchComments().then(data => {
            comments = (Object.values(data)).reverse();
        })
    }

    const replyToComment = async (id, content) => {
        answerToComment.id = id;
        answerToComment.preview = content.replace(/<[^>]*>?/gm, '').split(/\s+/).slice(0,6).join(" ") + " ...";
        await tick();
        scrollIntoView("#write-comment");
    }

    const scrollIntoView = (href) => {
        const el = document.querySelector(href);
        if (!el) return;
        el.scrollIntoView({
            behavior: 'smooth'
        });
    }

</script>

<div class="col-md-9 mt-3 border border-secondary rounded px-3 py-1">

    <div class="mb-2 mt-3 pb-0">
        <h3 class="mb-3 site-header mt-1" id="write-comment"><i class="fas fa-comments me-1"></i> Kommentare</h3>
    </div>

    <CommentFormComponent {config} {cid} {answerToComment} reloadComments={loadComments} />

    {#if comments === undefined}
        <p class="mt-4 mb-4"><i class="fas fa-circle-notch fa-spin"></i> Kommentare werden geladen...</p>
    {:else}
        {#if comments.length === 0}
            <div class="bg-light rounded p-3 mb-3 no-comments text-darkgreen">
                <i class="fas fa-info me-1"></i>
                Noch keine Kommentare vorhanden. Seien Sie jetzt der Erste!
            </div>
        {/if}

        {#each comments as comment, index}
            <div class="bg-light rounded p-3 mb-3">
                {#if comment.author !== undefined}
                    <button class="btn btn-sm btn-light border-lightdark float-end" on:click={() => {replyToComment(comment.comment_id, comment.content)}}><i class="fas fa-reply me-1"></i> Antworten</button>
                {/if}
                <CommentContent {config} {comment} reloadComments={loadComments} />

            </div>
            {#each comment.answers as answer, index}
                <div class="d-flex flex-row">
                    <div class="px-3 py-1 flex-shrink-1 text-darkgreen">
                        <i class="fas fa-reply"></i>
                    </div>
                    <div class="bg-light rounded p-3 mb-3 w-100">
                        <CommentContent {config} comment={answer} reloadComments={loadComments} />
                    </div>
                </div>
            {/each}
        {/each}
    {/if}

</div>


<style>
    h3 {
        font-size: 22px;
    }

    .no-comments {
        font-size: 18px;
        color: #406343;
    }
</style>
